import cn from 'classnames'
import React from 'react'

//
import { ButtonNew, IconNew } from '..'

import { filterTypes } from './index'
import Link from 'next/link'
import Image from 'next/image'

const Filter = ({ title = '', items = [], type = '', inverted = false, selectOnClick = false }) => {
  const getFilterItems = (items, itemsShown = items.length) => {
    return items.map((item, i) => {
      const { id, icon, img, label, value, url, active, handleClick } = item
      return (
        <li
          key={`filter-${id}-${i}`}
          className={cn('c-filter__list-item', {
            'is-hidden': i >= itemsShown,
            'c-filter__list-item--tag': type === filterTypes.tags
          })}
        >
          {url ? (
            renderLinkComponent(item)
          ) : (
            <ButtonNew
              classes={cn('c-filter__button c-button--filter', {
                'is-active': active
              })}
              onClick={
                selectOnClick
                  ? () => {
                      handleClick(value, id)
                    }
                  : undefined
              }
            >
              {icon && <IconNew classes="c-filter__link-icon" name={icon} size={28} />}

              {img ? (
                <img
                  loading="lazy"
                  className="c-filter__link-image"
                  src={img.url}
                  alt={img.alt}
                  title={img.title}
                  width="32"
                  height="32"
                />
              ) : null}

              {label}
            </ButtonNew>
          )}
        </li>
      )
    })
  }

  return (
    <div
      className={cn('c-filter', {
        'c-filter--inverted': inverted
      })}
    >
      <h2 className="c-filter__title">{title}</h2>

      {items.length > 0 && (
        <ul
          className={cn('c-filter__list', {
            'c-filter__list--countries': type === filterTypes.countries,
            'c-filter__list--tags': type === filterTypes.tags
          })}
        >
          {getFilterItems(items)}
        </ul>
      )}
    </div>
  )
}

const renderLinkComponent = (i) => {
  const { id, icon, label, img, url, active, type, handleClick, countryIsoCode } = i
  if (id === '0') {
    if (url && !countryIsoCode) {
      return (
        <div className="c-filter__link-wrapper">
          <Link
            href={url}
            className={cn('c-filter__link', {
              'is-active': active
            })}
          >
            {icon && <IconNew classes="c-filter__link-icon" name={icon} size={28} />}
            {img ? (
              type === filterTypes?.countries ? (
                <img
                  loading="lazy"
                  src={img.url}
                  alt={img.alt}
                  title={img.title}
                  width="32"
                  height="32"
                />
              ) : (
                <img
                  loading="lazy"
                  className="c-filter__link-image"
                  src={img.url}
                  alt={img.alt}
                  title={img.title}
                  width="32"
                  height="32"
                />
              )
            ) : null}
            {label}
          </Link>
        </div>
      )
    }
    return (
      <div className="c-filter__link-wrapper">
        <div
          role="button"
          onClick={handleClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleClick(e)
            }
          }}
          tabIndex={0}
          className={cn('c-filter__link c-filter__btn', {
            'is-active': active
          })}
        >
          {icon && <IconNew classes="c-filter__link-icon" name={icon} size={28} />}
          {img ? (
            type === filterTypes?.countries ? (
              <Image loading="lazy" src={img} alt={label} title={label} width="32" height="32" />
            ) : (
              <img
                loading="lazy"
                className="c-filter__link-image"
                src={img}
                alt={label}
                title={label}
                width="32"
                height="32"
              />
            )
          ) : null}
          {label}
        </div>
      </div>
    )
  }
  return url ? (
    <div className="c-filter__link-wrapper">
      <Link
        href={url}
        className={cn('c-filter__link', {
          'is-active': active
        })}
      >
        {icon && <IconNew classes="c-filter__link-icon" name={icon} size={28} />}
        {img ? (
          type === filterTypes?.countries ? (
            <img
              loading="lazy"
              src={img.url}
              alt={img.alt}
              title={img.title}
              width="32"
              height="32"
            />
          ) : (
            <img
              loading="lazy"
              className="c-filter__link-image"
              src={img.url}
              alt={img.alt}
              title={img.title}
              width="32"
              height="32"
            />
          )
        ) : null}
        {label}
      </Link>
    </div>
  ) : null
}

export default Filter
